module.exports = __webpack_public_path__ + "static/media/logo-docusign.c6462901.png";